/* eslint-disable */
import { v4 as uuid } from "uuid";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { useEffect, useState } from "react";
import { getCacheData } from "../../services/CacheService";
import { limpiaCodigo } from "../../utils/utils";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  id: null,
  id_proveedor: null,
  descripcion_proveedor: "",
  codigo_externo: ""
};

const nameItemText = "Código Externo";
//
// ########################################################################### 
//
const CodigoExternoDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [proveedores, setProveedores] = useState([]);
  const [valueACProveedor, setValueACProveedor] = useState(null);
  const [inputValueACProveedor, setInputValueACProveedor] = useState("");
  //
  // ################################################################################
  //
  useEffect(() => {
    loadProveedores();

    if (actionCrud !== "new") {
      setItemCrudLocal(itemCrud);
      setValueACProveedor({
        id: itemCrud.id_proveedor,
        label: itemCrud.descripcion_proveedor,
      });
      setInputValueACProveedor(itemCrud.descripcion_proveedor);
    }
  }, []);
  //
  // ################################################################################
  //
  const loadProveedores = async () => {
    const response = await getCacheData("proveedor")
    if (response.ok) {
      let _response = response.data.data;

      console.log('------------------------------');
      console.log('im in ');
      console.log('_response');
      console.log(_response);
      console.log('------------------------------');




      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion + (item.contacto ? " - " + item.contacto : "")
        });
      });
      setProveedores(_var);
    } else {
      setProveedores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {

    if (!valueACProveedor) {
      setMessage({
        severity: "error",
        messageText: "Debes seleccionar el Proveedor",
      });
      setShowMessage(true);
      return;
    }

    if (!itemCrudLocal.codigo_externo) {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar el Código Externo",
      });
      setShowMessage(true);
      return;
    }

    save();
  };
  //
  // ########################################################################## 
  //
  const save = async () => {

    let _itemCrud = {
      id: actionCrud === "new" ? uuid() : itemCrudLocal.id,
      id_proveedor: valueACProveedor.id,
      descripcion_proveedor: valueACProveedor.label,
      codigo_externo: limpiaCodigo(itemCrudLocal.codigo_externo).toUpperCase(),
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrudLocal.id;
    }

    const success = onSave(_itemCrud, actionCrud);

    if (success) {
      setItemCrudLocal(initialState);
      setValueACProveedor(null);
      setInputValueACProveedor("");
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="sm"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Autocomplete
                id="id-material"
                size="small"
                value={
                  valueACProveedor && valueACProveedor.id
                    ? valueACProveedor
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACProveedor(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    id_proveedor: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACProveedor ?? ""}
                onInputChange={(event, newInputValue) => {
                  setInputValueACProveedor(newInputValue);
                }}
                options={proveedores}
                getOptionLabel={(option) => option.label || ""}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Proveedor"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              // evita que abra/cierre el dropdown
                              e.stopPropagation();
                              loadProveedores();
                            }}
                          >
                            <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="codigo_externo"
                label="Código Externo"
                variant="outlined"
                size="small"
                name="codigo_externo"
                value={itemCrudLocal.codigo_externo || ""}
                onChange={handleChange}
              />
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
            >
              <Button
                sx={{ mr: 1 }}
                variant="contained"
                size="small"
                onClick={handleSave}
                startIcon={<SaveIcon />}
              >
                Guardar
              </Button>

              <Button
                variant="outlined"
                size="small"
                onClick={handleCloseDialog}
              >
                Cerrar
              </Button>
            </Box>
          </Grid>
        </DialogContent>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default CodigoExternoDialog;
